import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "select", "submitButton"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return

    const allFieldsFilled = this.fieldTargets.every((field) => field.value.trim().length > 0)
    const allSelectsFilled = this.selectTargets.every((select) => select.value.trim().length > 0)

    this.submitButtonTarget.disabled = !(allFieldsFilled && allSelectsFilled)
  }
}
